import { Injectable, inject } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { Auth } from "@angular/fire/auth";

@Injectable({
  providedIn: "root",
})
export class GuestGuard implements CanActivate {
  private auth = inject(Auth);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      // Wait for Firebase Auth to initialize
      const unsubscribe = this.auth.onAuthStateChanged((user) => {
        if (user) {
          // User is authenticated, redirect to dashboard
          this.router.navigate(["/dashboard"]);
          subscriber.next(false);
        } else {
          // User is not authenticated, allow access
          subscriber.next(true);
        }
        subscriber.complete();
        unsubscribe();
      });
    });
  }
}
